import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
    name: 'removePTags',
    standalone: true,
})
export class RemovePTags implements PipeTransform {
    transform(value: string): string {
        const valueWithOutP = value.replace(/^<p>/, '').replace(/<\/p>$/, '');
        return valueWithOutP;
    }
}
